<template>
    <div id="loginPage" class="warp" :style="{backgroundImage: 'url(' + bgUrl + ')' }" v-loading="loginloding">
        <div class="content">
            <img v-if="titleUrl" :src="titleUrl" :alt="altStr">
            <div v-else class="placeholder-div"></div>
            <div class="login-tabs">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="职工登录" name="employee">
                        <el-input class="user" placeholder="请输入登录账号" maxlength=30 v-model="loginForm.userName"  @keyup.enter.native="submit"  clearable> 
                            <i slot="prefix" class="iconfont">&#xe67d</i>
                        </el-input>
                        <el-input  type="password" class="pwd" placeholder="请输入密码"  maxlength=20 v-model="loginForm.password"  @keyup.enter.native="submit"  clearable>
                            <i slot="prefix" class="iconfont">&#xe67f</i>
                        </el-input>
                        <div class="captcha-row">
                            <el-input class="captcha-input" placeholder="请输入验证码" maxlength=4 v-model="captchaCode" @keyup.enter.native="submit" clearable>
                                <i slot="prefix" class="iconfont">&#xe67f</i>
                            </el-input>
                            <img class="captcha-img" :src="captchaImg" @click="fetchCaptcha" title="点击刷新验证码" />
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="管理员登录" name="admin">
                        <el-input class="user" placeholder="请输入登录账号" maxlength=30  v-model="loginForm.userName" @keyup.enter.native="submit" clearable> 
                            <i slot="prefix" class="iconfont">&#xe67d</i>
                        </el-input>
                        <el-input class="pwd" placeholder="请输入密码"  maxlength=20 v-model="loginForm.password" @keyup.enter.native="submit"  type="password" clearable>
                            <i slot="prefix" class="iconfont">&#xe67f</i>
                        </el-input>
                        <div class="captcha-row">
                            <el-input class="captcha-input" placeholder="请输入验证码" maxlength=4 v-model="captchaCode" @keyup.enter.native="submit" clearable>
                                <i slot="prefix" class="iconfont">&#xe67f</i>
                            </el-input>
                            <img class="captcha-img" :src="captchaImg" @click="fetchCaptcha" title="点击刷新验证码" />
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <!-- <el-checkbox class="login-auto" v-model="checked">自动登录</el-checkbox> -->
                <el-button class="login-btn" type="primary" @click="submit">登 录</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import * as storage from "utils/sessionStorage";
import bgSrc from '../assets/img/loginBg.png'
import titleSrc from "../assets/img/title.png"
import { getHomeConfig, getCaptcha } from "api/com"
import { JSEncrypt } from 'jsencrypt'
import Cookies from "js-cookie";
export default {
    name: "LoginPage",
    data() {
        return {
            loginloding: false,
            activeName: 'employee',
            // checked: true,
            loginForm:{
                userName: '',
                password: ''
            },
            bgUrl: '',
            titleUrl: '',
            altStr: '',
            captchaImg: '',
            captchaKey: '',
            rsaPublicKey: '',
            captchaCode: ''
        };
    },
    async created() {
      this.loginloding = true;
      let res = await getHomeConfig({
        domainName: document.domain+'/login'
      })
      if(res.code === 200 && res.data) {
        this.titleUrl = res.data.beforeLogoUrl ? res.data.beforeLogoUrl : titleSrc;
        this.altStr = res.data.fullName ? res.data.fullName : '';
        this.bgUrl = res.data.beforeBgUrl ? res.data.beforeBgUrl : bgSrc;
        document.title = res.data.fullName ? res.data.fullName : '';
      } else {
        this.titleUrl = titleSrc;
        this.bgUrl = bgSrc;
      }
      this.loginloding = false;
      this.fetchCaptcha();
    },
    async mounted(){
        if(storage.getCookie('SET_USER_TYPE')){
            this.activeName=storage.getCookie('SET_USER_TYPE');
        }
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        },
        async fetchCaptcha() {
            const res = await getCaptcha();
            if (res.code === 0 || res.code === 200) {
                this.captchaImg = res.data.image;
                this.captchaKey = res.data.captchaKey;
                this.rsaPublicKey = res.data.rsaPublicKey;
                this.captchaCode = '';
            }
        },
        submit(){
            if(this.loginForm.userName==''){
                this.$message({
                    type: 'error',
                    message:  '账户不正确！请重试'
                })
                return;
            }
            if(this.loginForm.password==''||this.loginForm.password.length<6){
                this.$message({
                    type: 'error',
                    message:  '账户密码不正确！请重试'
                })
                return;
            }
            if(!this.captchaCode){
                this.$message({
                    type: 'error',
                    message: '请输入验证码'
                })
                return;
            }
            const encryptor = new JSEncrypt();
            encryptor.setPublicKey(this.rsaPublicKey);
            const encryptedPassword = encryptor.encrypt(this.loginForm.password);
            let obj={
                type:this.activeName,
                loginForm:{
                    userName: this.loginForm.userName,
                    password: '123',
                    encryptedPassword,
                    terminal: 'pc',
                    captchaKey: this.captchaKey,
                    captchaCode: this.captchaCode,
                }
            }
            this.$store.dispatch("login",obj).then(
                result => {
                    storage.setData('loginType','')
                    result.data && Cookies.set('areaId', result.data.areaId);
                    this.$router.push({name:'home'});
                },
                result => {
                    this.fetchCaptcha();
                }
            );
        }
    }
};

</script>

<style lang="scss" scoped>
#loginPage {
    width: 100%;
    height: 100%;
    // background: url("~@/assets/img/loginBg.png") no-repeat center;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    .content {
        margin: 0 auto;
        width: 624px;
        height: 520px;
        padding-top: 140px;
        img,.placeholder-div {
          width: 324px;
          height: 60px;
          margin-left: calc((624px - 324px) / 2);
        }
        .login-tabs {
            height: 424px;
            margin-top: 30px;
            padding: 53px  calc((100% - 400px) / 2) 0;
            width: 400px;
            background: #fff;
            box-shadow:0px 2px 4px 0px rgba(221,221,221,0.5);
            border-radius:4px;
            .user {
                margin-top: 30px;
                height: 40px;
                font-size: 14px;
                color: #666666;
                i:after {
                    content:'|';
                    padding-left: 20px;
                    box-sizing: border-box;
                }
            }
            .pwd {
                @extend .user
            }
            .captcha-row {
                display: flex;
                align-items: center;
                margin-top: 20px;
                .captcha-input {
                    flex: 1;
                    height: 40px;
                    font-size: 14px;
                    color: #666666;
                }
                .captcha-img {
                    width: 120px;
                    height: 38px;
                    margin-left: 10px;
                    cursor: pointer;
                    border-radius: 4px;
                    border: 1px solid #dcdfe6;
                }
            }
        }
        .login-auto{
            display: block;
            height: 16px;
            margin-top: 30px;
        }
        .login-btn {
            background: -webkit-linear-gradient(left, #70CE97 , #34C5D7); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(right, #70CE97 , #34C5D7); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(right, #70CE97 , #34C5D7); /* Firefox 3.6 - 15 */
            background: linear-gradient(to right, #70CE97 , #34C5D7); /* 标准的语法 */
            margin-top: 30px;
            font-size: 16px;
            color: #FFFFFF;
        }
    }
    
}
</style>
